import { combineReducers } from 'redux';
import produce from 'immer';
import { ArtifactAction, ArtifactActionType } from '../../actions/artifactActions';

const loading = (state = false, action: ArtifactAction) => {
  switch (action.type) {
    case ArtifactActionType.LIST_ARTIFACTS:
      return true;
    case ArtifactActionType.LIST_ARTIFACTS_OK:
    case ArtifactActionType.LIST_ARTIFACTS_ERROR:
      return false;
    default:
      return state;
  }
};

const loadingError = (state = '', action: ArtifactAction) => {
  switch (action.type) {
    case ArtifactActionType.LIST_ARTIFACTS:
      return '';
    case ArtifactActionType.LIST_ARTIFACTS_ERROR:
      return action.error;
    default:
      return state;
  }
};

const deleting = (state = false, action: ArtifactAction) => {
  switch (action.type) {
    case ArtifactActionType.DELETE_ARTIFACTS:
      return true;
    case ArtifactActionType.DELETE_ARTIFACTS_OK:
    case ArtifactActionType.DELETE_ARTIFACTS_ERROR:
      return false;
    default:
      return state;
  }
};

const deletingError = (state = '', action: ArtifactAction) => {
  switch (action.type) {
    case ArtifactActionType.DELETE_ARTIFACTS:
      return '';
    case ArtifactActionType.DELETE_ARTIFACTS_ERROR:
      return action.error;
    default:
      return state;
  }
};

type LoadingLinkState = { loadingLink: boolean; loadingLinkError: string };
type DeletingState = { deleting: boolean; deletingError: string };

export type ArtifactState = LoadingLinkState & DeletingState;

interface ArtifactStatesById {
  [artifactId: string]: ArtifactState;
}

const byId = (state: ArtifactStatesById = {}, action: ArtifactAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ArtifactActionType.GET_ARTIFACT_LINK: {
        draft[action.artifactId] = {
          ...draft[action.artifactId],
          loadingLink: true,
          loadingLinkError: '',
        };
        break;
      }
      case ArtifactActionType.GET_ARTIFACT_LINK_OK: {
        draft[action.artifactId].loadingLink = false;
        break;
      }
      case ArtifactActionType.GET_ARTIFACT_LINK_ERROR: {
        draft[action.artifactId].loadingLink = false;
        draft[action.artifactId].loadingLinkError = action.error;
        break;
      }
      case ArtifactActionType.DELETE_ARTIFACT: {
        draft[action.artifactId] = {
          ...draft[action.artifactId],
          deleting: true,
          deletingError: '',
        };
        break;
      }
      case ArtifactActionType.DELETE_ARTIFACT_OK: {
        draft[action.artifactId].deleting = false;
        break;
      }
      case ArtifactActionType.DELETE_ARTIFACT_ERROR: {
        draft[action.artifactId].deleting = false;
        draft[action.artifactId].deletingError = action.error;
        break;
      }
      default:
        return state;
    }
  });

export default combineReducers({ loading, loadingError, deleting, deletingError, byId });
